export default function NotFound() {
  return (
    <div style={{ padding: 20 }}>
      <h1>404 - Page not found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}